// extracted by mini-css-extract-plugin
export default {"recos":"N7-z","productCardOverride":"O7-z","rowHasBadge":"P7-z"};